import { html as a } from "@scalar-org/html-templates";
import { rawIcons as c } from "./raw-icons.js";
const r = (t) => c[t.src] || a`
<img
  src="${t.src}"
  alt="${t.title}"
  style="object-fit: contain"
  class="${t.mask ? "mask-image" : ""}"/>
`;
export {
  r as guideIconHtml
};
